import React from "react"
import { RenderElementProps } from "slate-react"

const HeadingBase = ({ children, attributes }: RenderElementProps) => {
    return (
        <div
            {...attributes}
            className="font-gibson mb-5 text-3xl font-semibold last:mb-0 sm:text-4xl lg:mb-7 lg:text-6xl"
        >
            {children}
        </div>
    )
}

export default HeadingBase
